(() => {
  const initializeHeroDS = (scopeDS = document) => {
    const reduceMotionDS = window.matchMedia('(prefers-reduced-motion: reduce)');

    scopeDS.querySelectorAll('[data-hero-ds]').forEach((heroDS) => {
      if (heroDS.dataset.parallaxInitialized === 'true') return;

      const imageDS = heroDS.querySelector('.heroDS__image');
      if (!imageDS) return;

      let frameDS = null;

      const updateParallaxDS = () => {
        frameDS = null;

        if (reduceMotionDS.matches) {
          imageDS.style.transform = '';
          return;
        }

        if (window.innerWidth < 750) {
          imageDS.style.transform = '';
          return;
        }

        const rectDS = heroDS.getBoundingClientRect();
        const viewportHeightDS = window.innerHeight;
        const isVisibleDS = rectDS.bottom > 0 && rectDS.top < viewportHeightDS;
        if (!isVisibleDS) return;

        const scrollDistanceDS = Math.max(0, -rectDS.top);
        const strengthDS = 0.2;
        imageDS.style.transform = `translate3d(0, ${scrollDistanceDS * strengthDS}px, 0)`;
      };

      const requestUpdateDS = () => {
        if (frameDS !== null) return;
        frameDS = window.requestAnimationFrame(updateParallaxDS);
      };

      window.addEventListener('scroll', requestUpdateDS, { passive: true });
      window.addEventListener('resize', requestUpdateDS);
      reduceMotionDS.addEventListener('change', requestUpdateDS);
      requestUpdateDS();

      heroDS.dataset.parallaxInitialized = 'true';
    });
  };

  initializeHeroDS();
  document.addEventListener('shopify:section:load', (eventDS) => initializeHeroDS(eventDS.target));
})();
